import { Box, Checkbox, Chip, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { BtnBack, BtnCancelForm, BtnClear, BtnConfirmSelect, BtnExportExcel, BtnSave, BtnSearch } from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import React, { useEffect, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { GetMenuPermission } from "utilities/SystemFunction";
import { Extension, FnAxios, FnDialog, I18n } from "utilities/utilities";
import "../Equipment/Equipment.css";
import moment from "moment";
import InputNumberItem from "components/Input/InputNumber";
import UploadFile from "components/Input/UploadFile";
import { useLocation, useNavigate } from "react-router";
import { List as LINQ } from "linqts";
import HTMLReactParser from "html-react-parser";
import CustomTablePagination from "../IncomeExpenses/Ticket/components/CustomTablePagination";

const EquipmentCusoffForm = () => {
    const [lstData, setData] = useState([]);
    const [arrDataCusoff, setArrDataCusoff] = useState([]);
    const location = useLocation();
    const searchParams = location.search;
    const sMode = new URLSearchParams(searchParams).get("sMode");
    const sID = new URLSearchParams(searchParams).get('sID')
    const navigate = useNavigate();
    const onBack = () => navigate("/EquipmentList?sMode=" + sMode);
    const [arrImport, setarrImport] = useState([])
    const currentDate = new Date(); // Get the current date
    const dStart = new Date(currentDate.getFullYear() - 5, 0, 1);
    const dEnd = new Date(currentDate.getFullYear(), 11, 31);
    const [arrEquipmentType, setarrEquipmentType] = useState([]);
    const [selected, setSelected] = useState<readonly number[]>([]);
    const [selectedCusoff, setSelectedCusoff] = useState<readonly number[]>([]);
    const isSelectedCusoff = (id: number) => selectedCusoff.indexOf(id) !== -1;
    const isSelected = (id: number) => selected.indexOf(id) !== -1;
    const [nNetPriceYear, setNetPriceYear] = useState(0);
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            dStart: dStart,
            dEnd: dEnd,
        } as any,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission
    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const onClearData = () => {
        form.setValue("nEquipmenTypeID", []);
    };

    const onGetEquipment = () => {
        let ObjForm = form.getValues();
        let param = {
            nStart: ObjForm.dStart ? ObjForm.dStart.valueOf() : null,
            nEnd: ObjForm.dEnd ? ObjForm.dEnd.valueOf() : null,
            lstEquipmenTypeID: ObjForm.nEquipmenTypeID ? ObjForm.nEquipmenTypeID : []
        };
        AxiosFn.Post(`Equipment/GetEquipmentCusOff`, param, (result) => {
            let arrData = new LINQ<any>(arrDataCusoff).Select(s => s.nEquipmentID).ToArray();
            let arrClone: any[] = result.lstDataCusOff;
            let arrEquipment = arrClone.length > 0 ? arrClone.filter((f) => !arrData.includes(f.nEquipmentID)) : [];
            let arrDataNew = new LINQ<any>(arrEquipment).OrderBy((w) => w.dReceive).ToArray();
            // ตารางข้างบนตรงค้นหา
            if (arrDataNew.length > 0) {
                let nOrder = 1;
                arrDataNew.forEach((f) => {
                    f.nOrder = nOrder;
                    nOrder++;
                });
            }
            setData(arrDataNew);
            setNetPriceYear(result.nNetPriceYear);
        })
    }

    const getFormInitial = () => {
        AxiosFn.Get(`Equipment/GetFormInitial`, {}, (result) => {
            setarrEquipmentType(result.lstEquipmentCusOffType);
        })
    }

    useEffect(() => {
        getFormInitial();
        onGetEquipment();
    }, []);


    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = lstData.map((n) => n.nEquipmentID);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (id: number) => {

        const selectedIndex = selected.indexOf(id);
        let newSelected: readonly number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleSelectAllClickCusoff = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = arrDataCusoff.map((n) => n.nEquipmentID);
            setSelectedCusoff(newSelected);
            return;
        }
        setSelectedCusoff([]);
    };

    const handleClickCusoff = (id: number) => {
        const selectedIndex = selectedCusoff.indexOf(id);
        let newSelected: readonly number[] = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedCusoff, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedCusoff.slice(1));
        } else if (selectedIndex === selectedCusoff.length - 1) {
            newSelected = newSelected.concat(selectedCusoff.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedCusoff.slice(0, selectedIndex),
                selectedCusoff.slice(selectedIndex + 1)
            );
        }
        setSelectedCusoff(newSelected);
    };


    const handleSelectTable = (arrID) => {

        let arrClone: any[] = lstData;
        let arrnParentID = arrClone.length > 0 ? arrClone.filter((f) => arrID.includes(f.nEquipmentID)) : [];

        let arrNewItem = arrDataCusoff.length > 0 ? arrDataCusoff : [];
        arrNewItem.push(...arrnParentID);

        let arrDataNew = new LINQ<any>(arrNewItem).OrderBy((w) => w.dReceive).ToArray();
        // ตารางตัดจำหน่าย
        if (arrDataNew.length > 0) {
            let nOrder = 1;
            arrDataNew.forEach((f) => {
                f.nOrder = nOrder;
                nOrder++;
            });
        }

        let arrEquipmentID = arrClone.length > 0 ? arrClone.filter((f) => !arrID.includes(f.nEquipmentID)) : [];
        let arrData = new LINQ<any>(arrEquipmentID).OrderBy((w) => w.dReceive).ToArray();
        // ตารางข้างบนตรงค้นหา
        if (arrData.length > 0) {
            let nOrder = 1;
            arrData.forEach((f) => {
                f.nOrder = nOrder;
                nOrder++;
            });
        }

        setArrDataCusoff(arrDataNew);
        setData(arrData);
        setSelected([]);
    };

    const handleCancleTable = (arrID) => {
        let arrClone: any[] = arrDataCusoff;
        let arrEquipmentID = arrClone.length > 0 ? arrClone.filter((f) => arrID.includes(f.nEquipmentID)) : [];

        let arrNewItem = lstData.length > 0 ? lstData : [];
        arrNewItem.push(...arrEquipmentID);
        let arrData = new LINQ<any>(arrNewItem).OrderBy((w) => w.dReceive).ToArray();
        // ตารางข้างบนตรงค้นหา
        if (arrData.length > 0) {
            let nOrder = 1;
            arrData.forEach((f) => {
                f.nOrder = nOrder;
                nOrder++;
            });
        }

        // ตารางตัดจำหน่าย
        let arrnParentID = arrClone.length > 0 ? arrClone.filter((f) => !arrID.includes(f.nEquipmentID)) : [];
        let arrDataNew = new LINQ<any>(arrnParentID).OrderBy((w) => w.dReceive).ToArray();
        if (arrDataNew.length > 0) {
            let nOrder = 1;
            arrDataNew.forEach((f) => {
                f.nOrder = nOrder;
                nOrder++;
            });
        }
        setArrDataCusoff(arrDataNew);
        setData(arrData);
        setSelectedCusoff([]);

    };

    const onSubmit = (e) => {
        if (arrDataCusoff.length === 0 && sID === null) {
            DialogFn.Warning("กรุณาเลือกรายการตัดจำหน่ายอย่างน้อย 1 รายการ");
        } else if (arrImport.length === 0) {
            DialogFn.Warning("กรุณาอัปโหลดไฟล์");
        } else {
            let param = {
                sID: sID ? sID : "",
                nCutoffDate: form.getValues("dCutoff").valueOf(),
                nCutoffNo: form.getValues("nCutoffNo"),
                fFile: arrImport ?? [],
                lstDataCusoff: arrDataCusoff,
                nNetPriceYear: nNetPriceYear,
            };
            DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
                DialogFn.BlockUI();
                AxiosFn.Post(`Equipment/SaveCusoffEquipment`, param, (result) => {
                    DialogFn.UnBlockUI();
                    DialogFn.Success(`บันทึกสำเร็จ`);
                    DialogFn.CloseSubmit()
                    navigate("/EquipmentList?sMode=" + sMode);
                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
            });
        }
    };

    //ดึงข้อมูลมาแก้ไข
    const getCusOffEdit = () => {
        let Param = {
            sID: sID ? sID : ""
        };
        DialogFn.BlockUI();
        AxiosFn.Post(`Equipment/GetCusoffEquipmentEdit`, Param, (result) => {
            DialogFn.UnBlockUI();
            if (sID) {
                setArrDataCusoff(result.lstDataCusoff);
                form.setValue(`nCutoffNo`, result.nCutoffNo);
                form.setValue("dCutoff", moment(result.nCutoffDate));
                setNetPriceYear(result.nNetPriceYear);
                setarrImport(result.fFile);
            }
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };

    useEffect(() => {
        getCusOffEdit();
    }, []);

    const handdleExportReport = (e) => {
        DialogFn.BlockUI();
        let ObjForm = form.getValues();
        let param = {
            lstDataCusoff: arrDataCusoff,
            nCutoffDate: ObjForm.dCutoff ? ObjForm.dCutoff.valueOf() : null,
            nCusoffNo: ObjForm.nCutoffNo,
            nNetPriceYear: nNetPriceYear
        }
        let sFileName = `รายงานตัดจำหน่าย.xlsx`
        AxiosFn.DowloadFileBlob(`Equipment/onExportCusOffReport`, param, sFileName, (result) => {
            DialogFn.UnBlockUI();
        });
    }

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [pageCusoff, setPageCusoff] = React.useState(0);
    const [rowsPerPageCusoff, setRowsPerPageCusoff] = React.useState(10);

    return (
        <>
            <FormProvider {...form}>
                {sID === null && (
                    <>
                        <div className='div-search-equipment'>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Typography fontWeight={500}>วันที่ได้มา (กรรมการตรวจรับ)<span style={{ color: "red" }}> *</span></Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography fontWeight={500}>ประเภทครุภัณฑ์</Typography>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <DatePickerItem
                                        minDate={dStart}
                                        maxDate={form.watch("dEnd")}
                                        required={true}
                                        name={"dStart"}
                                        id={"dStart"}
                                        label={`${I18n.SetText("Equipment.sDateStart")}`}
                                        fullWidth
                                        disabled={!isPermission}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <DatePickerItem
                                        minDate={form.watch("dStart")}
                                        maxDate={dEnd}
                                        required={true}
                                        name={"dEnd"}
                                        id={"dEnd"}
                                        label={`${I18n.SetText("Equipment.sDateEnd")}`}
                                        fullWidth
                                        disabled={!isPermission}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MultipleSelectItem
                                        id={'nEquipmenTypeID'}
                                        name={'nEquipmenTypeID'}
                                        label={`${I18n.SetText("Equipment.EquipmentType")}`}
                                        placeholder={`${I18n.SetText("Equipment.EquipmentType")}`}
                                        options={arrEquipmentType}
                                        required={false}
                                        disabled={!isPermission}
                                        limitTag={1}
                                    />
                                </Grid>
                                <Grid item flex={1} container gap={2} justifyContent="center">

                                    <BtnSearch id="search"
                                        onClick={() => onGetEquipment()}
                                    />
                                    <BtnClear id="ClearID"
                                        onClick={() => onClearData()}
                                    />
                                </Grid>

                                <Grid item xs={12} sx={{ mt: 2 }}>
                                    <Divider textAlign="left"><Chip className='equipment-chip font-weight-500' label={<Typography>เลือกรายการที่ต้องการตัดจำหน่าย <span style={{ color: "red" }}> *</span></Typography>} /></Divider>
                                </Grid>
                                <Grid item xs={12} >
                                    <TableContainer id='table-cusoff' component={Paper}>
                                        <Table sx={{ minWidth: 1000 }} >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell padding="checkbox" align='center' style={{ width: '30px', }}>
                                                        <Checkbox
                                                            color="primary"
                                                            indeterminate={selected.length > 0 && selected.length < lstData.length}
                                                            checked={lstData.length > 0 && selected.length === lstData.length}
                                                            disabled={!isPermission}
                                                            onChange={handleSelectAllClick}
                                                            inputProps={{
                                                                'aria-label': 'select all',
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell padding='none' align='center' style={{ width: '30px', }}>ที่</TableCell>
                                                    <TableCell padding='none' align='center' style={{ width: '70px', }}>วันที่ได้มา</TableCell>
                                                    <TableCell padding='none' align='center' style={{ width: '100px', }}>ประเภท/ลักษณะ</TableCell>
                                                    <TableCell padding='none' align='center' style={{ width: '100px', }}>รหัสครุภัณฑ์</TableCell>
                                                    <TableCell padding='none' align='center' style={{ width: '200px', }}>รายละเอียด</TableCell>
                                                    <TableCell padding='none' align='center' style={{ width: '70px', }}>ราคา</TableCell>
                                                    <TableCell padding='none' align='center' style={{ width: '80px', }}> {HTMLReactParser(`มูลค่าสุทธิ <br/> ณ 31 ธ.ค. ${nNetPriceYear}`)}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            {lstData.length > 0 ? (
                                                <TableBody>
                                                    {lstData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => {
                                                        const isItemSelected = isSelected(item.nEquipmentID);
                                                        return (
                                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer' }} key={item.nID}>
                                                                <TableCell padding="checkbox" align='center'>
                                                                    <Grid item xs={12} md={12} >
                                                                        <Checkbox
                                                                            color="primary"
                                                                            checked={isItemSelected}
                                                                            onClick={() => handleClick(item.nEquipmentID)}
                                                                            inputProps={{
                                                                                "aria-labelledby": `aria-${item.nEquipmentID}`,
                                                                            }}
                                                                            disabled={!isPermission}
                                                                        />
                                                                    </Grid>
                                                                </TableCell>
                                                                <TableCell padding='none' align='center'>
                                                                    {item.nOrder}
                                                                </TableCell>
                                                                <TableCell padding='none' align='center'>
                                                                    {item.sReceiveDate}
                                                                </TableCell>
                                                                <TableCell padding='none' align='center'>
                                                                    {item.sEquipmentType}
                                                                </TableCell>
                                                                <TableCell padding='none' align='center'>
                                                                    {item.sEquipmentNo}
                                                                </TableCell>
                                                                <TableCell padding='none' align='left'>
                                                                    <Typography fontSize={13}>
                                                                        {item.sEquipment}
                                                                    </Typography>
                                                                    {item.lstEquipmentItem.map((m, i) => {
                                                                        return (
                                                                            <Typography fontSize={13} key={i}>
                                                                                {m.sEquipmentItem}
                                                                            </Typography>
                                                                        )
                                                                    })}


                                                                </TableCell>
                                                                <TableCell padding='none' align='right'>
                                                                    {item.sPrice}
                                                                </TableCell>
                                                                <TableCell padding='none' align='right'>
                                                                    {item.sNetPriceYear}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            ) : (

                                                <TableRow key={"r-no-data"}>
                                                    <TableCell align="center" style={{ padding: "10px", backgroundColor: "white" }} colSpan={8}>
                                                        ไม่พบข้อมูล
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </Table>
                                    </TableContainer>
                                    <CustomTablePagination
                                        dataTable={lstData}
                                        rowsPerPage={rowsPerPage}
                                        setRowsPerPage={setRowsPerPage}
                                        page={page}
                                        setPage={setPage}
                                        colSpan={8}
                                        OptionRowsPerPage={[5, 10, 25, 50, 100]}
                                    />

                                </Grid>
                                {selected.length > 0 &&
                                    <Grid container justifyContent="center" sx={{ mt: 5, }}>

                                        <BtnConfirmSelect
                                            txt={"ยืนยันรายการที่เลือกตัดจำหน่าย"}
                                            id={'BtnConfirmSelect'}
                                            onClick={() => handleSelectTable(selected)}
                                        />

                                    </Grid>
                                }
                            </Grid>
                            <Grid container justifyContent="strat" sx={{ marginBottom: 3 }}></Grid>
                        </div>
                        <Grid container justifyContent="strat" sx={{ marginBottom: 3 }}></Grid>
                    </>
                )}
                <Grid item xs={12} sx={{ mt: 1 }}>
                    <Divider textAlign="left"><Chip className='equipment-chip font-weight-500' label={<Typography>รายการที่ตัดจำหน่าย <span style={{ color: "red" }}> *</span></Typography>} /></Divider>
                </Grid>
                <Grid
                    container
                    direction="row"
                    sx={{
                        justifyContent: "flex-end",
                        alignItems: "flex-start",
                    }}
                >
                    <BtnExportExcel id={"expReport"}
                        onClick={form.handleSubmit((e) => { handdleExportReport(e) })}
                    />
                </Grid>
                <Grid item xs={12} sx={{ minWidth: 1000, marginTop: 2 }}>
                    <TableContainer id='table-confirm' component={Paper}>
                        <Table sx={{ minWidth: 1000 }} >
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox" align='center' style={{ width: '30px', }}>
                                        <Checkbox
                                            color="primary"
                                            indeterminate={selectedCusoff.length > 0 && selectedCusoff.length < arrDataCusoff.length}
                                            checked={arrDataCusoff.length > 0 && selectedCusoff.length === arrDataCusoff.length}
                                            disabled={!isPermission}
                                            onChange={handleSelectAllClickCusoff}
                                            inputProps={{
                                                'aria-label': 'select all',
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell padding='none' align='center' style={{ width: '30px', }}>ที่</TableCell>
                                    <TableCell padding='none' align='center' style={{ width: '70px', }}>วันที่ได้มา</TableCell>
                                    <TableCell padding='none' align='center' style={{ width: '100px', }}>ประเภท/ลักษณะ</TableCell>
                                    <TableCell padding='none' align='center' style={{ width: '100px', }}>รหัสครุภัณฑ์</TableCell>
                                    <TableCell padding='none' align='center' style={{ width: '200px', }}>รายละเอียด</TableCell>
                                    <TableCell padding='none' align='center' style={{ width: '70px', }}>ราคา</TableCell>
                                    <TableCell padding='none' align='center' style={{ width: '80px', }}>{HTMLReactParser(`มูลค่าสุทธิ <br/> ณ 31 ธ.ค. ${nNetPriceYear}`)}</TableCell>
                                </TableRow>
                            </TableHead>
                            {arrDataCusoff.length > 0 ? (
                                <TableBody>
                                    {arrDataCusoff.slice(pageCusoff * rowsPerPageCusoff, pageCusoff * rowsPerPageCusoff + rowsPerPageCusoff).map((item) => {
                                        const isItemSelected = isSelectedCusoff(item.nEquipmentID);
                                        return (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer' }} key={item.nID}>
                                                <TableCell padding="checkbox" align='center'>
                                                    <Grid item xs={12} md={12} >
                                                        <Checkbox
                                                            color="primary"
                                                            checked={isItemSelected}
                                                            onClick={() => handleClickCusoff(item.nEquipmentID)}
                                                            inputProps={{
                                                                "aria-labelledby": `aria-${item.nEquipmentID}`,
                                                            }}
                                                            disabled={!isPermission}
                                                        />
                                                    </Grid>
                                                </TableCell>
                                                <TableCell padding='none' align='center'>
                                                    {item.nOrder}
                                                </TableCell>
                                                <TableCell padding='none' align='center'>
                                                    {item.sReceiveDate}
                                                </TableCell>
                                                <TableCell padding='none' align='center'>
                                                    {item.sEquipmentType}
                                                </TableCell>
                                                <TableCell padding='none' align='center'>
                                                    {item.sEquipmentNo}
                                                </TableCell>
                                                <TableCell padding='none' align='left'>
                                                    <Typography fontSize={13}>
                                                        {item.sEquipment}
                                                    </Typography >
                                                    {item.lstEquipmentItem.map((m, i) => {
                                                        return (
                                                            <Typography fontSize={13} key={i}>
                                                                {m.sEquipmentItem}
                                                            </Typography >
                                                        )
                                                    })}

                                                </TableCell>
                                                <TableCell padding='none' align='right'>
                                                    {item.sPrice}
                                                </TableCell>
                                                <TableCell padding='none' align='right'>
                                                    {item.sNetPriceYear}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            ) : (
                                <TableRow key={"r-no-data"}>
                                    <TableCell align="center" style={{ padding: "10px", backgroundColor: "white" }} colSpan={8}>
                                        ไม่พบข้อมูล
                                    </TableCell>
                                </TableRow>
                            )}
                        </Table>
                    </TableContainer>
                    <CustomTablePagination
                        dataTable={arrDataCusoff}
                        rowsPerPage={rowsPerPageCusoff}
                        setRowsPerPage={setRowsPerPageCusoff}
                        page={pageCusoff}
                        setPage={setPageCusoff}
                        colSpan={8}
                        OptionRowsPerPage={[5, 10, 25, 50, 100]}
                    />

                </Grid>
                {selectedCusoff.length > 0 &&
                    <Grid container justifyContent="strat" sx={{ mt: 2 }}>

                        <BtnCancelForm
                            txt={"ยกเลิกตัดจำหน่าย"}
                            id={'BtnConfirmSelect'}
                            onClick={() => handleCancleTable(selectedCusoff)}
                        />

                    </Grid>
                }
                <Grid container justifyContent="strat" sx={{ marginBottom: 5 }}></Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <DatePickerItem
                            maxDate={moment()}
                            required={true}
                            name={"dCutoff"}
                            id={"dCutoff"}
                            label={"วันที่ตัดจำหน่าย"}
                            fullWidth
                            disabled={!isPermission || sID !== null}
                            IsDisablePortal={true}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <InputNumberItem
                            id={`nCutoffNo`}
                            name={`nCutoffNo`}
                            label={`${I18n.SetText("Equipment.nCutoffNo")}`}
                            required={true}
                            IsShowMessageError={false}
                            IsAllowScientific={false}
                            maxDigits={0}
                            ShowDigits={0}
                            maxInteger={10}
                            IsComma={true}
                            disabled={!isPermission || sID !== null}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <UploadFile
                            id="sReceiveMaterialFile"
                            name={"sReceiveMaterialFile"}
                            label={"เอกสารแนบ"}
                            required={true}
                            arrFile={arrImport}
                            setarrFile={setarrImport}
                            sFolderTemp="CutoffEquipmentImage"
                            IsFolder={false}
                            IsMultiple={true}
                            Extension={[...Extension.FileTicketZip]}
                            nLimitFile={30}
                            sLimitFile={"MB"}
                            onClearFile={() => { }}
                            sPositionText="right"
                            IsCrop={true}
                            cropRatio={16 / 9}
                            cropMovable={true}
                            cropResize={true}
                            cropShape='retangle'
                            modeDisplay='gallery'
                            disabled={!isPermission}
                        />
                    </Grid>
                </Grid>

                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit((e) => onSubmit(e), (err) => console.log("err", err))}
                        />
                    </Grid>
                </Grid>
            </FormProvider >
        </ >
    )
}
export default EquipmentCusoffForm